<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_work_edit')" :view-config="auth('b_work_viewmanage')" :custom-view="customView" @customView="data => $refs.gantt.load(data)">
				<template #search>
					<m-search ref="searchForm">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="工单状态">
							<c-select name="work_states" :options="orderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="计划结束时间" colspan="2">
							<c-datetime range start-name="plan_end_date_begin" end-name="plan_end_date_end"></c-datetime>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="关联单据号">
							<c-input name="ref_code"></c-input>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_work_create')" v-lock="lock('b_work_create')" color="main" prepend-icon="tf-add" @click="editWork()">创建工单</c-button>
					<c-button v-if="auth('b_work_export') && !customView" v-lock="lock('b_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_work_export') && !customView" v-lock="lock('b_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_work_create') && !customView" v-lock="lock('b_work_create')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_work_export')" v-lock="lock('b_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_work_export')" v-lock="lock('b_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_work_print')" v-lock="lock('b_work_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-dropdown>
						<c-button prepend-icon="tf-batch">批量操作</c-button>

						<template #menu>
							<c-menu-list>
								<!-- 修改状态 -->
								<c-menu-list v-if="auth('b_work_start') || auth('b_work_finish') || auth('b_work_withdraw') || auth('b_work_cancel')">
									<c-menu-item icon="tf-edit-border">状态</c-menu-item>
									<template #menu>
										<c-menu-item v-if="auth('b_work_start')" v-lock="lock('b_work_start')" icon="tf-start" @click="editState(null, 2)">开始</c-menu-item>
										<c-menu-item v-if="auth('b_work_finish')" v-lock="lock('b_work_finish')" icon="tf-end" @click="editState(null, 3)">结束</c-menu-item>
										<c-menu-item v-if="auth('b_work_withdraw')" v-lock="lock('b_work_withdraw')" icon="tf-recall" @click="editState(null, -1)">撤回</c-menu-item>
										<c-menu-item v-if="auth('b_work_cancel')" v-lock="lock('b_work_cancel')" icon="tf-cancel" @click="editState(null, 4)">取消</c-menu-item>
									</template>
								</c-menu-list>
								<c-menu-item v-if="auth('b_work_priority')" v-lock="lock('b_work_priority')" icon="tf-priority" @click="editPriority">优先级</c-menu-item>
								<c-menu-item v-if="auth('b_work_delete')" v-lock="lock('b_work_delete')" icon="tf-trash" color="red" @click="batchRemoveWork">删除</c-menu-item>
							</c-menu-list>
						</template>
					</c-dropdown>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-view" @click="customView = !customView">{{customView ? '返回列表' : '查看甘特图'}}</c-button>
					<c-button v-if="auth('b_work_log')" v-lock="lock('b_work_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_work_log')" v-lock="lock('b_work_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.id}})">{{data.work_code}}</c-link>
				</template>

				<!--产品来源-->
				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>

				<!--产品类型-->
				<template #product_type="{data}">
					<c-state dict="productTypeName" :value="data.product_type"></c-state>
				</template>
				
				<!--工单进度-->
				<template #process_rate="{data}">
					<process-rate :key="data._timestamp" :id="data.id" @output="$refs.view.refresh()"></process-rate>
				</template>
				
				<!--工单进度%-->
				<template #work_progress="{data}">
					<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--工单明细进度%-->
				<template #work_detail_progress="{data}">
					<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--工单状态-->
				<template #work_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
				</template>
				
				<!--优先级-->
				<template #priority="{data}">
					<c-state dict="priorityDic" tag :value="data.priority"></c-state>
				</template>
				
				<!--工期状态-->
				<template #plan_date_state="{data}">
					<c-state type="expectedDate" :value="data.expected_date"></c-state>
				</template>
				
				<!--关联单据-->
				<template #ref_code="{data}">
					<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
				</template>
				
				<!--打印次数-->
				<template #print_count="{data}">
					<span v-if="data.print_count == 0">-</span>
					<span v-else>{{data.print_count}}</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_work_edit')" v-lock="lock('b_work_edit')" icon="tf-edit" @click="editWork(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_work_print')" v-lock="lock('b_work_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('workDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_work_priority')" v-lock="lock('b_work_priority')" icon="tf-priority" @click="editPriority(data)">优先级</c-table-button>
						<c-table-button v-if="auth('b_work_copy')" v-lock="lock('b_work_copy')" icon="tf-copy" @click="copyWork(data)">复制</c-table-button>
						<c-table-button v-if="auth('b_work_collabtask_add')" v-lock="lock('b_work_collabtask_add')" icon="tf-add" @click="createCollabTask(data)">发起协同</c-table-button>
						<c-table-button v-if="auth('b_work_start')" v-lock="lock('b_work_start')" :disabled="!(data.work_state == 1)" icon="tf-start" @click="editState(data, 2)">开始</c-table-button>
						<c-table-button v-if="auth('b_work_finish')" v-lock="lock('b_work_finish')" :disabled="!((data.work_state == 1 || data.work_state == 2))" icon="tf-end" @click="editState(data, 3)">结束</c-table-button>
						<c-table-button v-if="auth('b_work_withdraw')" v-lock="lock('b_work_withdraw')" :disabled="!(data.work_state != 1)" icon="tf-recall" @click="editState(data, -1)">撤回</c-table-button>
						<c-table-button v-if="auth('b_work_cancel')" v-lock="lock('b_work_cancel')" :disabled="!(data.work_state != 4)" icon="tf-cancel" @click="editState(data, 4)">取消</c-table-button>
						<c-table-button v-if="auth('b_work_share')" v-lock="lock('b_work_share')" icon="tf-share" @click="shareWork(data)">分享</c-table-button>
						<c-table-button v-if="auth('b_work_delete')" v-lock="lock('b_work_delete')" icon="tf-trash" @click="removeWork(data)">删除</c-table-button>
					</template>
				</c-table-column>

				<template #customView>
					<gantt ref="gantt" scene="work" @workDetail="editWork"></gantt>
				</template>
			</view-list>
			
			<!--创建、编辑工单信息弹窗-->
			<work-edit ref="workEdit" @resolve="updateMethod"></work-edit>
			<!--编辑任务优先级弹窗-->
			<priority-edit ref="priorityEdit" @resolve="$refs.view.refresh()"></priority-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import gantt from './gantt.vue'
	import workEdit from "@/pages/production/work_edit.vue";
	import priorityEdit from "@/pages/production/work_edit_priority.vue";

	export default {
		components: {
			gantt,
			workEdit,
			priorityEdit
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic'])
		},
		
		data() {
			return {
				workType: 3,
				customView: false,
				editFlag: false
			}
		},
		
		mounted(){
			this.scanCode({
				parse: true,	//解析参数
				success: scanData => {
					//工单二维码
					if(scanData.in_work_id){
						this.$refs.searchForm.clear();
						this.$refs.searchForm.search({
							id: scanData.in_work_id,
						}, data => {
							data[0] && this.$refs.searchForm.set({work_code: data[0].work_code});
						});
					}
				}
			});
		},
		
		methods: {
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER_HAVE_ORDER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			updateMethod(){
				//修改
				if(this.editFlag){
					this.$refs.view.refresh();
				}else{
					this.$refs.view.update();
				}
			},
			
			/******新建/编辑工单*******/
			editWork(data) {
				if(data){
					this.editFlag = true;
				}else{
					this.editFlag = false;
				}
				this.$refs.workEdit.open(data);
			},
			
			/******复制工单*******/
			copyWork(data) {
				this.$refs.workEdit.open(data, true);
			},
			
			/**编辑任务优先级*/
			editPriority(data) {
				if(!data){
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					this.$refs.priorityEdit.batchOpen(ids);
				}else{
					this.$refs.priorityEdit.open(data);
				}
			},

			
			/******发起协同任务（关联当前工单）*******/
			createCollabTask(data) {
				this.globalDialog('collabTaskEdit', {
					data: {
						ref_type: 3,
						ref_id: data.id,
						ref_code: data.work_code
					}
				});
			},
			
			/****批量删除工单***/
			batchRemoveWork(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条工单记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/work/delete/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******删除工单************/
			removeWork(data){
				this.$confirm({
					message:'确认删除工单【'+data.work_code+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/work/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******修改工单状态************/
			editState(data, work_state){
				if(!data){
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					this.batchEditStateHandler(ids, work_state);
					
				}else{
					//取消需要弹出确认
					if(work_state == 4){
						this.$confirm({
							title:'确认取消工单？',
							message:'取消后，工单'+data.work_code+'将不允许报工，支持撤回操作',  // 提示内容,
							// buttonName: '确定',  // 确定按钮文字
							cancelButton: true,  // 是否显示取消按钮
							resolve: () => {
								this.editStateHandler(data.id, work_state)
							},  // 确定按钮回调
							cancel: () => {},  // 取消按钮回调
						});
					}else{
						this.editStateHandler(data.id, work_state)
					}
				}
			},
			
			/******修改工单状态(提交数据)************/
			editStateHandler(work_id, work_state){
				this.request({
					url: '/work/editState',
					data: {
						id: work_id , 
						work_state: work_state,
					},
					loading: true,
					success: data => {
						var mess = '';
						if(work_state == -1){
							mess = '撤回成功';
						}else if(work_state == 2){
							mess = '开始成功';
						}else if(work_state == 3){
							mess = '结束成功';
						}else if(work_state == 4){
							mess = '取消成功';
						}
						
						this.$message({
							message: mess,  // 提示内容,
							type: 'success'
						});
						//刷新
						this.$refs.view.refresh();
					}
				});
			},

			/******批量修改工单状态(提交数据)************/
			batchEditStateHandler(ids, work_state){
				this.request({
					url: '/work/editState/batch',
					data: {
						ids: ids , 
						work_state: work_state,
					},
					loading: true,
					success: data => {
						var mess = '';
						if(work_state == -1){
							mess = '撤回成功';
						}else if(work_state == 2){
							mess = '开始成功';
						}else if(work_state == 3){
							mess = '结束成功';
						}else if(work_state == 4){
							mess = '取消成功';
						}
						
						let Mtype = 'success';
						let message = mess + data.success_count + '条';
						if(data.fail_count > 0 && data.success_count > 0){
							Mtype = 'warn';
							message += '，失败'+data.fail_count+'条';
						}else if(data.fail_count > 0 && data.success_count == 0){
							Mtype = 'fail'
							message += '，失败'+data.fail_count+'条';
						}else{
							message = mess + data.success_count + '条记录';
						}
						this.$message({
							message: message,  // 提示内容,
							type: Mtype
						});
						//刷新
						this.$refs.view.refresh();
					}
				});
			},

			/******分享工单************/
			shareWork(data){
				let productInfo = (data.product_name || '') + ' ' + (data.product_spec || '');
				let workTitle = `产品信息：${productInfo}\n工单编号：${data.work_code}\n查看生产进度：`;

				this.globalDialog('shareDialog', {
						data: {
							workType: this.workType, 
							workId: data.id, 
							workCode: data.work_code,					//业务单号
							title: '分享工单进度',						//弹框标题
							qrTitle: '工单：' + data.work_code,			//二维码标题
							shareLikeTitle: workTitle,	 				//分享链接标题
						}
					}
				)
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>